import React from "react";
import "../styles/components/info-box.css";

const InfoBox = (props) => (
  <div className="info-box" style={props.style}>
    <div className="info-box-detail">
      <p>
        <ion-icon name="time" />
        {props.time}
      </p>
      {!props.isLive && (
        <React.Fragment>
          <p>
            {"Speed: "}
            {formatSpeedRatio(props.speedRatio)}
          </p>
          <p>
            <ion-icon name="hourglass" />
            {formatSeconds(props.interval)}
          </p>
        </React.Fragment>
      )}
    </div>

    <div className="info-box-note">
      <p className="note">تمامی اعداد بر روی نمودار به میلی ثانیه می باشد.</p>
    </div>
  </div>
);

const formatSeconds = (seconds) => {
  const min = parseInt(seconds / 60, 10);
  const sec = seconds % 60;
  if (min < 1) {
    return `${sec}s`;
  }
  return `${min}m ${sec}s`;
};

const formatSpeedRatio = (speedRatio) => {
  const ratio = 1 / speedRatio;
  return `${ratio}x `;
};

export default InfoBox;
